import { cn } from "../../shared/utils";

interface ErrorSpanProps {
    customStyles?: string;
    text: string;
}

export default function ErrorSpan({ customStyles = "", text }: ErrorSpanProps) {
    return (
        <span
            className={cn(
                `animate-fade cursor-default justify-center px-2 pb-2 font-semibold text-red-500`,
                customStyles,
            )}>
            {text}
        </span>
    );
}
